import { POrderSummaryCompleted } from "./POrderSummaryCompleted";
import { RDate } from "../../core";
import { POrderSummaryCancelled } from "./POrderSummaryCancelled";
export function fromResponseState(params) {
    const { state, orderInfo } = params.orderSummaryResponse;
    const { createdAt, requestedFulfillmentTime, timezone } = orderInfo;
    const restaurantAddress = {
        name: params.orderSummaryResponse.restaurantName,
        street: params.orderSummaryResponse.restaurantAddressStreet,
        postCode: params.orderSummaryResponse.restaurantAddressPostCode,
        city: params.orderSummaryResponse.restaurantAddressCity,
    };
    const fulfillmentMethodType = orderInfo.fulfillmentMethodType === "Takeaway"
        ? {
            type: "Takeaway",
            restaurantAddress,
        }
        : {
            type: orderInfo.fulfillmentMethodType,
        };
    const isPreorder = getIsPreorder(createdAt, requestedFulfillmentTime, timezone);
    switch (state.tag) {
        case "Placed":
            return { type: "Loading", isFinal: false };
        case "WaitingForPayment":
            return { type: "WaitingForPayment", isFinal: false };
        case "WaitingForDispatch":
            return {
                type: "WaitingForDispatch",
                openAt: state.openAt,
                isPreorder,
                isFinal: false,
            };
        case "WaitingForConfirmation": {
            const date = requestedFulfillmentTime !== null
                ? RDate.fromString(requestedFulfillmentTime, timezone)
                : null;
            return {
                type: "WaitingForConfirmation",
                fulfillmentMethodType,
                isPreorder,
                fulfillmentTime: date
                    ? { date: date.format("DD.MM.YYYY"), hour: date.fullHour }
                    : null,
                isFinal: false,
            };
        }
        case "Completed":
            return new POrderSummaryCompleted({
                restaurantAddress,
                completedAt: RDate.fromString(state.contents[1], state.contents[0]),
                isPreorder,
                fulfillmentMethodType,
                restaurantPhones: params.orderSummaryResponse.restaurantPhones,
                now: () => RDate.now(state.contents[0]),
            });
        case "Cancelled":
            return new POrderSummaryCancelled({
                cartStorageManager: params.cartStorageManager,
                reason: state.contents,
                isOnlinePayment: orderInfo.onlinePayment,
                restaurantPhones: params.orderSummaryResponse.restaurantPhones,
                redirectToRestaurant: params.redirectToRestaurant,
            });
    }
}
function getIsPreorder(createdAt, requestedFulfillmentTime, timezone) {
    if (requestedFulfillmentTime === null) {
        return false;
    }
    const orderingDate = RDate.fromString(createdAt, timezone);
    const fulfullmentDate = RDate.fromString(requestedFulfillmentTime, timezone);
    return !orderingDate.isSame(fulfullmentDate, "day");
}
